import BlogContent from "../components/SingleBlog/BlogContent/Index";
import BlogImage from "../components/SingleBlog/BlogImage/Index";
import Footer from "../components/Footer/Index";
import Header from "../components/Header/Index";
import React from "react";
import Seo from "../components/Seo/Seo";
import { graphql } from "gatsby";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import { getImage } from "gatsby-plugin-image";

export default function BlogPost({ location, data }) {
  const post = data?.wpPost;
  const recentBlogList = data?.recentPost?.edges;

  const breadcrumbTitle = post.breadcrumbTitle?.breadcrumbTitle || post?.title;
  const breadcrumbs = [
    {
      name: "Home",
      slug: "https://www.designstudiouiux.com/",
    },
    {
      name: "Blog",
      slug: "https://www.designstudiouiux.com/blog/",
    },
    {
      name: breadcrumbTitle,
      slug: "",
    },
  ];

  return (
    <MantineProvider>
      <main className="main_canvas">
        <Seo
          title={post?.blogSeo?.seoBlog?.title}
          description={post?.blogSeo?.seoBlog?.description}
          canonical={`https://www.designstudiouiux.com/blog/${post?.slug}/`}
          
          image={getImage(post?.featuredImage?.node?.localFile)?.images?.fallback?.src}
          altText={post?.featuredImage?.node?.altText}
          breadcrumbs={breadcrumbs}
          noIndex={post?.blogSeo?.seoBlog?.noIndex}
          blogDetailsSchm={post}
        />

        <Header BlogImage={true} blogHeader={true} />

        <BlogImage
          featuredImage={post?.featuredImage?.node?.localFile}
          featuredImageAlt={post?.featuredImage?.node?.altText}
          breadcrumbs={breadcrumbs}
        />

        <BlogContent
          title={post.title}
          description={post.content}
          date={post.date}
          updatedDate={post.modified}
          author={post.author.node.firstName + " " + post.author.node.lastName}
          authorImage={post.author.node.avatar.url}
          readTime={post.blogSeo.readingTime}
          audioUrl={post?.blogSeo?.audioLink?.url}
          path={location.pathname}
          recentBlogList={recentBlogList}
        />
      </main>
      <Footer />
    </MantineProvider>
  );
}

export const query = graphql`
  query ($slug: String!) {
    wpPost(slug: { eq: $slug }) {
      id
      title
      content
      slug
      breadcrumbTitle {
        breadcrumbTitle
      }
      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(
                quality: 90
                formats: WEBP
                layout: CONSTRAINED
                placeholder: BLURRED
              )
            }
          }
        }
      }
      author {
        node {
          firstName
          lastName
          avatar {
            url
          }
        }
      }
      date(formatString: "DD MMMM YYYY", locale: "en")
      modified(formatString: "DD MMMM YYYY", locale: "en")
      blogSeo {
        readingTime
        audioLink {
          url
        }
        seoBlog {
          description
          title
          noIndex
        }
      }
    }

    recentPost: allWpPost(sort: { date: DESC }, limit: 3) {
      edges {
        node {
          title
          uri
          featuredImage {
            node {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    formats: WEBP
                    layout: CONSTRAINED
                    placeholder: BLURRED
                  )
                }
              }
            }
          }
          author {
            node {
              firstName
              lastName
              avatar {
                url
              }
            }
          }
          blogSeo {
            smallFeatureImage {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    formats: WEBP
                    layout: CONSTRAINED
                    placeholder: BLURRED
                  )
                }
              }
            }
          }
          date(formatString: "DD MMMM YYYY", locale: "en")
          modified(formatString: "DD MMMM YYYY", locale: "en")
          excerpt
        }
      }
    }
  }
`;
